/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebAnkietyPodpisanaPost$Params {
  'X-Rodzaj-Ankiety'?: string;
}

export function apiWebAnkietyPodpisanaPost(http: HttpClient, rootUrl: string, params?: ApiWebAnkietyPodpisanaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiWebAnkietyPodpisanaPost.PATH, 'post');
  if (params) {
    rb.header('X-Rodzaj-Ankiety', params['X-Rodzaj-Ankiety'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiWebAnkietyPodpisanaPost.PATH = '/api/web/ankiety/podpisana';
